import React from "react";
import { List, Drawer } from "antd-mobile";
import { getMenuList } from "../../ajax/index.js";
import Drawertwo from "./Drawertwo.js";
import light from "../../assets/images/home/img_triangle_dark.png";

class Drawerone extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      open: false,
      MenuListDatafour: [], //四级分类数组
      indexid: 1,
    };
  }
  //抽屉展示隐藏
  onOpenChange = (id, listId) => {
    if (this.state.indexid === id) {
      this.setState({
        open: !this.state.open,
      });
    } else {
      this.setState({
        open: true,
      });
    }
    this.setState({
      MenuListDatafour: [], //二级分类数组
    });
    getMenuList(id, this.props.language).then((res) => {
      if (res.data.length < 1) {
        if (listId === "") {
          this.props.historys.push("/systemerror");
        } else {
          this.props.historys.push(
            "/errorCodeList/" +
              id +
              "," +
              this.props.language +
              "," +
              this.props.buId+
              "," +
              this.props.type
          );
        }
        this.setState({
          open: false,
        });
      } else {
        this.setState({
          MenuListDatafour: res.data,
          indexid: id,
        });
      }
      setTimeout(function () {
        [...document.getElementsByClassName("list-cont")].map((item) => {
          if (item) {
            let _p = item.parentNode;
            let _h = _p.clientHeight;
            if (_h > 51) {
              _p.className = "autoHeightli";
            }
          }
        });
      }, 100);
    });
  };
  Hidenbtn = () => {
    this.setState({
      open: false,
    });
  };
  render() {
    let bodyh = document.body.clientHeight;
    let h = this.props.MenuListDatathree.length * 51;
    let height = bodyh - h;

    return (
      <div className="menu-style">
        <div className="drawerone">
          <ul className="my-list">
            {this.props.MenuListDatathree.map((i) => {
              var activeclass =
                i.id === this.state.indexid && this.state.open
                  ? "active spanclass2"
                  : "spanclass2";
              return (
                <li
                  key={i.id}
                  onClick={(id) => {
                    this.onOpenChange(i.id, i.listId);
                  }}
                >
                  <div className="list-cont">
                    {i.name}
                    <span className={activeclass}>
                      <img src={light} width="6" height="12" />
                    </span>
                  </div>
                </li>
              );
            })}
            {/* 第二层抽屉 四级分类*/}
            <Drawer
              className="my-drawer drawer-layer-1"
              style={{ minHeight: document.documentElement.clientHeight }}
              enableDragHandle
              contentStyle={{
                color: "#A6A6A6",
                textAlign: "center",
                paddingTop: 0,
              }}
              sidebar={
                <Drawertwo
                  MenuListDatafour={this.state.MenuListDatafour}
                  language={this.props.language}
                  buId={this.props.buId}
                  type={this.props.type}
                />
              }
              open={this.state.open}
              onOpenChange={this.onOpenChange}
              position="right"
              touch={false}
            ></Drawer>
          </ul>
        </div>
        <div
          className="hidenbtn hidenbtnWrap2"
          onClick={this.Hidenbtn}
          style={{ height: height }}
        ></div>
      </div>
    );
  }
}
export default Drawerone;



// WEBPACK FOOTER //
// ./src/pages/Home/Drawerone.js